import { createFeatureSelector, createSelector } from '@ngrx/store';

import { DataVisualizationState } from '@core/models/data-visualization/data-visualization.state';

export const selectorDataVisualization =
  createFeatureSelector<DataVisualizationState>('dataVisualization');

export const selectDataVisualizationState = createSelector(
  selectorDataVisualization,
  (state: DataVisualizationState) => state
);

export const selectOpenedVisualizationWindows = createSelector(
  selectorDataVisualization,
  (state: DataVisualizationState) => state.openedVisualizationWindows
);

export const selectAvailableVisualizations = createSelector(
  selectorDataVisualization,
  (state: DataVisualizationState) => state.componentStates.availableVisualizations
);

export const selectTimelineVisualization = createSelector(
  selectorDataVisualization,
  (state: DataVisualizationState) => state.componentStates.timelineVisualization
);

export const selectMapVisualization = createSelector(
  selectorDataVisualization,
  (state: DataVisualizationState) => state.componentStates.mapVisualization
);

export const selectCalendarVisualization = createSelector(
  selectorDataVisualization,
  (state: DataVisualizationState) => state.componentStates.calendarVisualization
);

export const selectListVisualization = createSelector(
  selectorDataVisualization,
  (state: DataVisualizationState) => state.componentStates.listVisualization
);

export const selectOccupationVisualization = createSelector(
  selectorDataVisualization,
  (state: DataVisualizationState) => state.occupationVisualization
);

export const selectOccupationLoading = createSelector(
  selectorDataVisualization,
  (state: DataVisualizationState) => state.occupationVisualization.loading
);

export const selectOccupationSitesInView = createSelector(
  selectorDataVisualization,
  (state: DataVisualizationState) => state.occupationVisualization.siteUidsInView
);

export const selectVisualizationContext = createSelector(
  selectorDataVisualization,
  (state: DataVisualizationState) => state.visualizationContext
);

export const selectIsVisualizationHydrating = createSelector(
  selectorDataVisualization,
  (state: DataVisualizationState) => state.isHydrating
);

export const selectAggregatorFilter = createSelector(
  selectorDataVisualization,
  (state: DataVisualizationState) => state.filterOnAggregator
);

export const selectTimelineTimeStep = createSelector(
  selectorDataVisualization,
  (state: DataVisualizationState) => state.timelineTimeStep
);

export const selectTimelineModificationDescriptors = createSelector(
  selectorDataVisualization,
  (state: DataVisualizationState) => state.timelineModificationDescriptors
);
